import Api, { configFormData } from "@/config/Api";

export default {
  getInvoices(options = {}) {
    return Api().get(`/invoices`, options);
  },
  getClientInvoices(clientId, options = {}) {
    return Api().get(`/invoices?client=${clientId}`, options);
  },
  addInvoices(data) {
    return Api().post(`/invoices`, data);
  },
  getInvoceId(invoiceId) {
    return Api().get(`/invoices/${invoiceId}`);
  },
  deleteInvoceId(invoiceId) {
    return Api().delete(`/invoices/${invoiceId}`);
  },
  sendInvoiceEmail({ data }) {
    return Api().post(`/invoices/send-email`, data, configFormData);
  },
  sendInvoiceSRI(data) {
    return Api().post(`/sri/signature/invoice`, data, {
      skipNetworkErrorNotification: true
    });
  },
  verifyInvoiceSRI(data, config = {}) {
    return Api().post(`/sri/signature/invoice/verify-status`, data, config);
  },
  getPayMethods() {
    return Api().get(`/payments-type`, {});
  },
  addPayments(data) {
    return Api().post("/me/payments", data);
  },
  updatePaymentsId(paymentId, data) {
    return Api().put(`/me/payments/${paymentId}`, data);
  },
  deletePaymentsId(data) {
    return Api().delete(`/me/payments/${data.id}`);
  },
  updateInvoiceId(invoiceId, data) {
    return Api().put(`/invoices/${invoiceId}`, data);
  },
  updateInvoiceStatus(data) {
    return Api().post(`/status/invoices`, data);
  },
  reactivateInvoice(invoiceId) {
    return Api().post(`/invoices/reactivate`, {
      user_business_invoice_id: invoiceId
    });
  },
  addProductsToInvoice(data) {
    return Api().post("/invoices/products", data);
  },
  updateProductsToInvoice(productId, data) {
    return Api().put(`/invoices/products/${productId}`, data);
  },
  deleteProductsToInvoice(productId) {
    return Api().delete(`/invoices/products/${productId}`);
  },
  invoiceDownload({ id }) {
    return Api().get(`/u/download/invoices?id=${id}`, {
      responseType: "arraybuffer"
    });
  },
  invoicePaid(data) {
    return Api().post("/invoices/paid", data);
  },
  /**
   * Marca un conjunto de facturas como cobradas/no-cobradas en una sola
   * request HTTP (en vez de N requests secuenciales).
   * @param {number[]} ids
   * @param {boolean} isPaid
   */
  invoicesBulkPaid(ids, isPaid = true) {
    return Api().post("/invoices/bulk-paid", { ids, is_paid: isPaid });
  },
  invoiceDownloadXML(userBusinessId, data) {
    return Api().post(`/invoices/downloadxml/${userBusinessId}`, data, {
      responseType: "blob"
    });
  },
  getIntegrationInvoices(options = {}) {
    return Api().get(`/integrations/invoice/api`, options);
  },
  getIntegrationInvoiceId(invoiceId) {
    return Api().get(`/integrations/invoice/api/${invoiceId}`);
  },
  getInstallments(invoiceId) {
    return Api().get(`/invoices/${invoiceId}/installments`);
  },
  syncInstallments(invoiceId, installments) {
    return Api().post(`/invoices/${invoiceId}/installments/sync`, {
      installments
    });
  },
  markInstallmentPaid(invoiceId, installmentId) {
    return Api().patch(
      `/invoices/${invoiceId}/installments/${installmentId}/mark-paid`
    );
  },
  getTimeline(invoiceId) {
    return Api().get(`/invoices/${invoiceId}/timeline`);
  },
  updateReminders(invoiceId, { enable_reminders }) {
    const endpoint = enable_reminders
      ? "/reminders/resume"
      : "/reminders/pause";
    return Api().post(endpoint, {
      document_type: "invoice",
      document_id: invoiceId
    });
  },
  // ════════ Métodos Batch (Optimizados para acciones masivas) ════════
  /**
   * Actualizar estado de múltiples facturas en un lote
   * @param {Array} invoiceIds - Array de IDs
   * @param {Object} statusData - Datos de estado a actualizar
   */
  updateInvoiceStatusBatch(invoiceIds, statusData) {
    return Api().post(`/status/invoices`, {
      invoice_ids: invoiceIds,
      ...statusData
    });
  },
  /**
   * Marcar múltiples facturas como pagadas
   * @param {Array} invoiceIds - Array de IDs
   * @param {Boolean} isPaid - true para marcar como pagada
   */
  async invoicePaidBatch(invoiceIds, isPaid = true) {
    // Procesar cada factura con el endpoint single (que existe y funciona)
    const promises = invoiceIds.map(invoiceId =>
      this.invoicePaid({
        user_business_invoice_id: invoiceId,
        is_paid: isPaid
      })
    );
    return Promise.all(promises);
  }
};
